@let vm = vm$ | async;
@let categoryDetails = categoryDetails$ | async;
@let selectedStoreInfo = selectedStoreInfo$ | async;
@let selectUserZipCode = selectUserZipCode$ | async;

<div id="filter-chip-container" class="hmf-mb-xs hmf-mb-lg-0">
	<div
		class="hmf-display-flex filter-chip-slider"
		[ngClass]="{'hmf-flex-wrap' : wrapChips}"
	>
		<div class="mobile-filter-chips hmf-display-flex hmf-align-items-center hmf-flex-wrap hmf-mx-s hmf-mx-lg-0 hmf-my-m hmf-my-lg-0">
			@for (filterType of vm?.selectedFilters | keyvalue; track trackByLabel($index, filterType)) {
				@for (filterLabel of filterType.value; track trackByFilter($index, filterLabel)) {
					<hmf-global-chips
						class="filter-chip hmf-px-0"
						[label]="{filterType, filterLabel, categoryDetails, selectedStoreInfo, selectUserZipCode}
						| buildChipLabel:true:filterLabelLookUp:filterDisplayTextMap:sameDayDeliveryEnabled()"
						[showCancelSign]="true"
						[isSelected]="false"
						(removeFilter)="removeFilter(filterType.key, filterLabel)"
					>
					</hmf-global-chips>
				}
			}
			@if (!isSelectedFilterEmpty) {
				<button hmf-action-text
						variant="secondary"
						class="clear-all-button hmf-align-items-center"
						altText="Clear all filters"
						ariaLabel="Clear all filters"
						(click)="removeFilters()">
					Clear All
				</button>
			}
		</div>
	</div>
</div>
